import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import navMenu from '../../../public/web/static/js/navMenu';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'Dashboard',
  data: function data() {
    return {
      menuPathArr: [],
      zhwy_routers: navMenu,
      // 政企信息平台人员菜单
      newList: [],
      defalutMenuList: []
    };
  },
  created: function created() {
    var meanuList = this.admin_routers;
    this.defalutMenuList = [{
      name: '小区动态',
      menuId: 1330
    }, {
      name: '资源管理',
      menuId: 1142
    }, {
      name: '收费管理',
      menuId: 1206
    }, {
      name: '支付管理',
      menuId: 1435
    }, {
      name: '任务通知管理',
      menuId: 1518
    }, {
      name: '物料管理',
      menuId: 1138
    }, {
      name: '保洁管理',
      menuId: 1161
    }, {
      name: '绿化管理',
      menuId: 1166
    }, {
      name: '报事报修管理',
      menuId: 1194
    }, {
      name: '投诉建议管理',
      menuId: 1334
    }, {
      name: '公共收益管理',
      menuId: 1493
    }, {
      name: '投票管理',
      menuId: 1511
    }, {
      name: '物业服务公示',
      menuId: 1501
    }, {
      name: '满意度调查管理',
      menuId: 1502
    }, {
      name: '室内装修管理',
      menuId: 1505
    }];
    this.newList = [];
    this.getNewMenu(this.admin_routers);
    console.log('--this.admin_routers--');
    console.log(this.admin_routers);
    console.log('--this.admin_routers--');
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['name'])), mapState({
    admin_routers: function admin_routers(state) {
      return state.permission.adminRouters;
    },
    // 后端生成菜单
    userTheme: function userTheme(state) {
      return state.user.userTheme;
    }
  })),
  methods: {
    handleZhwyMenuSelect: function handleZhwyMenuSelect(menu) {
      this.$router.push(menu.path);
      this.$store.commit('app/CHANGE_SIDEBAR', true);
      document.querySelector('.main-container').style.marginLeft = '210px';
      var chooseRouters = this.admin_routers.find(function (item) {
        if (!item.hidden && item.path !== '/') {
          return item.meta.title === menu.menuName;
        }
      }); // console.log('chooseRouters', chooseRouters)

      this.$store.dispatch('ChooseRouters', chooseRouters);
    },
    norma: function norma(ids, childrens) {
      for (var i = 0; i < childrens.length; i++) {
        if (ids === childrens[i].menuId) {
          this.newList.push({
            children: childrens[i].children,
            path: childrens[i].path,
            menuId: childrens[i].menuId,
            menuUpId: childrens[i].menuUpId,
            meta: childrens[i].meta,
            name: childrens[i].name
          });
        }
      }
    },
    getNewMenu: function getNewMenu(meanuList) {
      for (var i = 0; i < this.defalutMenuList.length; i++) {
        if (meanuList == null) {
          return null;
        }

        for (var j = 0; j < meanuList.length; j++) {
          if (meanuList[j].menuId) {
            if (this.defalutMenuList[i].menuId === meanuList[j].menuId) {
              this.newList.push({
                children: meanuList[j].children,
                path: meanuList[j].path,
                menuId: meanuList[j].menuId,
                menuUpId: meanuList[j].menuUpId,
                meta: meanuList[j].meta,
                name: meanuList[j].name
              });
            } else {
              if (meanuList[j].children) {
                this.norma(this.defalutMenuList[i].menuId, meanuList[j].children);
              }
            }
          }
        }
      }

      console.log('this.newList');
      console.log(this.newList);
      console.log('---this.newList---');
    },
    handleMenuSelect: function handleMenuSelect(menu) {
      this.menuPathArr = [];
      this.menuFormat(menu);
      console.log('跳转菜单', menu);
      this.$store.dispatch('ChooseRouters', menu);
    },
    // menuFormat(route) {
    //   console.log('route+++')
    //   console.log(route)
    //   this.menuPathArr.push(route.path)
    //   if (route.children && route.children.length > 0) {
    //     this.menuFormat(route.children[0])
    //     const menuPath = this.menuPathArr[this.menuPathArr.length - 2] + '/' + this.menuPathArr[this.menuPathArr.length - 1]
    //     console.log('1:',menuPath)
    //     this.$router.push(menuPath)
    //   } else if (route.children === null) {
    //     let pathUp = ''
    //     // 循环菜单列表，寻找上级menuId
    //     for (var j = 0; j < this.admin_routers.length; j++) {
    //       if (this.admin_routers[j].menuId) {
    //         // 找到相等的menuId
    //         if (route.menuUpId === this.admin_routers[j].menuId) {
    //           // 跳转
    //           pathUp = this.admin_routers[j].path
    //           const menuPath = pathUp + '/' + this.menuPathArr[this.menuPathArr.length - 1]
    //           console.log('2:',menuPath)
    //           this.$router.push(menuPath)
    //         } else {
    //           // 未找到相等的menuId，寻找其子集
    //           if (this.admin_routers[j].children) {
    //             const childrens = this.admin_routers[j].children
    //             // this.norma(newsList[i].menuId, this.admin_routers[j].children)
    //             for (var i = 0; i < childrens.length; i++) {
    //               if (route.menuUpId === childrens[i].menuId) {
    //                 pathUp = this.admin_routers[j].path
    //                 const menuPath = pathUp + '/' + this.menuPathArr[this.menuPathArr.length - 1]
    //                 console.log('3:',menuPath)
    //                 this.$router.push(menuPath)
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    //   this.$store.commit('app/CHANGE_SIDEBAR', true)
    //   document.querySelector('.main-container').style.marginLeft = '210px'
    // }
    menuFormat: function menuFormat(route) {
      console.log('route+++');
      console.log(route);
      this.menuPathArr.push(route.path);

      if (route.children && route.children.length > 0) {
        this.menuFormat(route.children[0]);
      }

      var menuPath = this.menuPathArr[this.menuPathArr.length - 2] + '/' + this.menuPathArr[this.menuPathArr.length - 1];
      console.log('menuPath+++');
      console.log(menuPath);
      this.$router.push(menuPath);
      this.$store.commit('app/CHANGE_SIDEBAR', true);
      document.querySelector('.main-container').style.marginLeft = '210px';
    }
  }
};